module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('quill-editor', {
    ref: "editor",
    attrs: {
      "content": _vm.content,
      "options": {
        modules: {
          toolbar: _vm.toolbar,
          keyboard: _vm.keyboard
        },
        placeholder: _vm.placeholder
      }
    },
    on: {
      "change": _vm.change,
      "blur": _vm.blur,
      "focus": _vm.focus,
      "ready": _vm.ready,
      "click": _vm.action
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5085210c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
// module id = 112
// module chunks = 0